var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.readonly || !_vm.internalValue
    ? _c(
        "c-input",
        _vm._b(
          {
            ref: "input",
            attrs: {
              id: _vm.id,
              type: _vm.inputType,
              placeholder: _vm.placeholder,
              readonly: _vm.readonly
            },
            on: { change: _vm.handleChange },
            model: {
              value: _vm.internalValue,
              callback: function($$v) {
                _vm.internalValue = $$v
              },
              expression: "internalValue"
            }
          },
          "c-input",
          _vm.$attrs,
          false
        )
      )
    : _c(
        "a",
        {
          staticClass: "is-read-only",
          attrs: { href: _vm.internalValue, target: "_blank" }
        },
        [_vm._v(_vm._s(_vm.internalValue))]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }